import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { ResponseMessage } from '../model/FormsEntity/responseForOnlineBooking';
import { AddressProofTypeModel } from '../model/masters/addressprooftype.model';
import { ApproveReject } from '../model/masters/ApproveRejectModel.model';
import { BankNameModel } from '../model/masters/BankNameModel.model';
import { branchContractDeputMaster } from '../model/masters/branchContractDeputMaster';
import { CategoryOfAppModel } from '../model/masters/CategoryOfApp.model';
import { FirstNameTypeModel } from '../model/masters/firstNameType.model';
import { FlatCategoryModel } from '../model/masters/flatCategory.model';
import { FormTypeModel } from '../model/masters/formType.model';
import { GenderModel } from '../model/masters/gender.model';
import { HousingFloorModel } from '../model/masters/HousingFloor.model';
import { HousingScheme } from '../model/masters/housingScheme.model';
import { IdProofTypeModel } from '../model/masters/IdProofTypeModel.model';
import { LocalityModel } from '../model/masters/locality.model';
import { MonthModel } from '../model/masters/month.model';
import { NationalityModel } from '../model/masters/nationality.model';
import { PaymentModeModel } from '../model/masters/PaymentMode.model';
import { positionMaster } from '../model/masters/positionMaster';
import { RelationNameModel } from '../model/masters/relationName.model';
import { SchemeModel } from '../model/masters/scheme.model';
import { StateModel } from '../model/masters/state.model';
import { TransactionDocumentModel } from '../model/masters/TransactionDocumentModel.model';
import { UriModel } from '../model/masters/uriModel.model';
import { UserUploadListModel } from '../model/masters/userUploadList.model';
import { YearModel } from '../model/masters/year.model';
import { YesNoModel } from '../model/masters/YesNo.model';
import { ZoneModel } from '../model/masters/zone.model';

@Injectable({ providedIn: 'root' })


export class MasterService {
  
    private masterUrl: string;
    private digilockerUrl: string;
    constructor(private http: HttpClient) {
        this.masterUrl = environment.baseUrl + 'masterData/';
        this.digilockerUrl = environment.baseUrl + 'digiLocker/';
        //   this.masterUrl = 'http://202.191.132.224:8086/dda/masterData/';
      

    }
    public getGenderList(value) {
        return this.http.get<GenderModel>(this.masterUrl + 'getGenderList');
    }
    public getRelationList(value) {
        return this.http.get<RelationNameModel>(this.masterUrl + 'getRelationList');
    }

    public getNationalityList(value) {
        return this.http.get<NationalityModel>(this.masterUrl + 'getNationalityList');
    }

    public getZone() {
        return this.http.get<ZoneModel>(this.masterUrl + 'getZoneList');
    }

    public getApproveReject() {
        return this.http.get<ApproveReject>(this.masterUrl + 'getApproveRejectList');
    }
    public getStateList(value) {
        return this.http.get<StateModel>(this.masterUrl + 'getStateList');
    }
    public getCityListByStateId(stateId) {
        return this.http.get<StateModel>(this.masterUrl + 'getCityListByStateId/' + stateId)
    }
    public getAddressProofTypeList(value) {
        return this.http.get<AddressProofTypeModel>(this.masterUrl + 'getAddressProofTypeList');
    }

    public getTransactionDocumentTypeList(value) {
        return this.http.get<TransactionDocumentModel>(this.masterUrl + 'getTransactionDocumentTypeList');
    }
    public getCategoryOfAppList(value) {
        return this.http.get<CategoryOfAppModel>(this.masterUrl + 'getCategoryOfAppList');
    }


    public getFormList() {
        return this.http.get<FormTypeModel>(this.masterUrl + 'getFormList');
    }

    public getFirstNameList() {
        return this.http.get<FirstNameTypeModel>(this.masterUrl + 'getFirstNameList');
    }

    public getIdProofList(value) {
        return this.http.get<IdProofTypeModel>(this.masterUrl + 'getIdProofList');
    }

    public getMonth() {
        return this.http.get<MonthModel>(this.masterUrl + 'getMonthList');
    }

    public getYear() {
        return this.http.get<YearModel>(this.masterUrl + 'getYearList');
    }
    public getFlatcategory() {
        return this.http.get<FlatCategoryModel>(this.masterUrl + 'getFlatCategoryList');
    }

    public getlocalityList() {
        return this.http.get<LocalityModel>(this.masterUrl + 'getLocalityList')

    }
    public getHousingSchemeList(value) {
        return this.http.get<HousingScheme>(this.masterUrl + 'getHousingSchemeList');
    }
    public getNatureOfPropertList(value) {
        return this.http.get<any>(this.masterUrl + 'getNatureOfPropertList/'+value);
    }

    public getHousingFloorList() {
        return this.http.get<HousingFloorModel>(this.masterUrl + 'getHousingFloorList')

    }
    public getSchemeList() {
        return this.http.get<SchemeModel>(this.masterUrl + 'getSchemeList')

    }

    public getBankNameList() {
        return this.http.get<BankNameModel>(this.masterUrl + 'getBankNameList')

    }

    public getYesNoList() {
        return this.http.get<YesNoModel>(this.masterUrl + 'getYesNoList')

    }

    public getPaymentModeList() {
        return this.http.get<PaymentModeModel>(this.masterUrl + 'getPaymentModeList')

    }

    public checkTokenStaus(userId){
        return this.http.get<ResponseMessage>(this.digilockerUrl + 'getDigilockerInfo/' +userId);
    }
    public getUploadedFileList(userId) {
        return this.http.get<UserUploadListModel>(this.digilockerUrl +'getUploadedFileList/'+userId);
      }
      public getIssuedDocList(userId) {
        return this.http.get<UriModel>(this.digilockerUrl +'getIssuedDocList/'+userId);
      }
      public getSalutationList() {
        return this.http.get<SchemeModel>(this.masterUrl + 'getSalutationList')

    }

    public getNumberList() {
        return this.http.get<any>(this.masterUrl + 'getNumberList')

    }
      public getDocumentViewByUri(viewDocModel) {
        const httpOptions = {
            'responseType'  : 'arraybuffer' as 'json'
             //'responseType'  : 'blob' as 'json'        //This also worked
          };
        return this.http.post<any>(this.digilockerUrl +'getParticularIssuedDoc',viewDocModel,httpOptions);
      }
   
      public getpositionMasterList() {
        return this.http.get<positionMaster>(this.masterUrl + 'getDesignationList');
    }
    public getbranchMasterList() {
        return this.http.get<branchContractDeputMaster>(this.masterUrl + 'getBranchDepuContList');
    }

    public getDDAHolidayList() {
        return this.http.get<any>(this.masterUrl + 'getDDAHolidayList');
    }
    public getPayHeadMasterListLD() {
        return this.http.get<any>(this.masterUrl + 'getPayHeadMasterListLD');    //getPayHeadMasterListLD
    }
    public getSlots(){
        return this.http.get<any>(this.masterUrl +'getParkSlotsList');
      }
      public getSubSlots(){
        return this.http.get<any>(this.masterUrl +'getParkSlotsSubList');
      }
   
    
}